<template>
  <div class="cbt">
    <div class="mv">
      <div class="u-containar-md">
        <h1>全国一斉 CBT模擬試験</h1>
        <picture>
          <source
            media="(max-width: 900px)"
            srcset="@/assets/images/magazines/exam_cbt_2025_ttlSP.svg"
          />
          <img src="@/assets/images/magazines/exam_cbt_2025_ttl.svg" alt="" />
        </picture>
      </div>
    </div>
    <div class="lead">
      <div class="u-containar-md">
        <div class="error">
          制限時間が終了しました。<br class="hiddenPc" />再度受験してください。
        </div>
        <p class="text">
          制限時間切れの場合、解答が保存されません。成績・解答を見る場合は、再受験してください。
        </p>
        <div class="btnArea">
          <Button
            :label="'再受験する'"
            primary
            :handleClick="
              () =>
                $router.push(
                  `/magazines/exam/cbt/${$route.params.category}/detail/1`
                )
            "
          />
          <Button
            :label="'CBT模擬試験トップへ戻る'"
            :handleClick="() => $router.push('/magazines/exam/cbt')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'CbtFail',
  components: {
    Button
  },
  setup() {
    localStorage.setItem('myAnswers', '')
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.mv {
  height: 200px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('~@/assets/images/magazines/exam_cbt_bgSP.png');
  background-size: cover;
  @include mixins.media() {
    height: 240px;
    background-image: url('~@/assets/images/magazines/exam_cbt_bg.png');
  }
  h1 {
    display: none;
  }
}

.lead {
  margin-top: 32px;
  @include mixins.media() {
    margin-top: 48px;
  }
  .error {
    font-size: 1.4rem;
    color: var.$color-red;
    line-height: 1.7;
    padding: 16px 18px;
    border: 1px solid var.$color-red;
    @include mixins.media() {
      margin-top: 48px;
    }
  }
  .text {
    margin-top: 24px;
    @include mixins.media() {
      margin-top: 32px;
    }
  }
  .btnArea {
    margin-top: 32px;
    @include mixins.media() {
      margin-top: 40px;
    }
    button + button {
      margin-top: 16px;
    }
  }
}
</style>
